export const iconGridStyle = {
  grid: 'flex flex-wrap gap-24',
  button:
    'flex flex-col items-center rounded hover:bg-hover h-90 aspect-square',
};
